import React from "react";
import GeneralQueryPage from "./GeneralQueryPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface GeneralQueryPageContainerProps extends RouteProps, withValidUserRoleProps {}

const GeneralQueryPageContainer = (props: GeneralQueryPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <GeneralQueryPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(GeneralQueryPageContainer);
